export const companyDetailsFlagsTranslations = {
  flags: {
    frequent: 'company_details-flags-frequent',
    nonFrequent: 'company_details-flags-non_frequent',
    agentRanking50: 'company_details-flags-agent_ranking_50',
    agentRanking100: 'company_details-flags-agent_ranking_100',
    agentRanking200: 'company_details-flags-agent_ranking_200',
    contractStatus: 'company_details-flags-contract_status',
    orgStatus: 'company_details-flags-opg_status',
    amplifyProgram: 'company_details-flags-amplify_program',
  },
}
